import { useState } from "react";
import { api } from "@/lib/api";
import { AppointmentDialog } from "@/components/crm/appointments/AppointmentDialog";

export const SCHEDULED = "Cita agendada";

// Moving a lead to "Cita agendada" without an active appointment asks for one; cancel keeps the previous stage.
export const useStageGuard = () => {
  const [pending, setPending] = useState(null);

  const guard = async (lead, { proceed, saved, revert }) => {
    const { data } = await api.get("/appointments", { params: { lead_id: lead.id, active: true } });
    if (data.length) return proceed();
    setPending({ lead, saved, revert });
    return undefined;
  };

  const dialog = (
    <AppointmentDialog open={Boolean(pending)} onOpenChange={(v) => !v && setPending(null)} lead={pending?.lead} setStage
                       onSaved={() => { pending?.saved?.(); setPending(null); }} onCancel={() => pending?.revert?.()} />
  );
  return { guard, dialog };
};
